module.exports = __webpack_public_path__ + "static/media/IMG_20191204_133526.f14d9068.jpg";